import { HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Defect } from "src/app/models/defect.model";
import { QueryStrings } from "src/app/models/emitter-events.models";
import { Inspection } from "src/app/models/inspection.model";
import { RequestService } from "src/app/services/request/request.service";

@Injectable({
	providedIn: "root",
})
export class AssetService {
	private httpOptions = {
		observe: "response",
	};

	constructor(public requestService: RequestService) {}

	public getAssetInspection(assetId: string, companyId: string, api: string): Observable<Inspection> {
		const url = `${api}/inspections/last?companyId=${companyId}&assetId=${assetId}`;
		return this.requestService.get<Inspection>({ url });
	}

	public getAssetDefects(assetId: string, companyId: string, api: string, query: QueryStrings) {
		const { sort, sortDir, page, perPage, ...remainingQueryStrings } = query;
		const url = `${api}/defects?page=${page}&perPage=${perPage}&sort=${sort}&sortDir=${sortDir}`;
		const data = { companyId, ...remainingQueryStrings, assetIds: [assetId] };

		return this.requestService.post<HttpEvent<Defect[]>>({ url, httpOptions: this.httpOptions, data });
	}
}
